import React, { FC } from 'react'

import { alpha, Backdrop, CircularProgress, useTheme } from '@mui/material'

export const CustomLoaderOverlay: FC<{ open?: boolean }> = ({ open = true }) => {
  const { palette } = useTheme()

  return (
    <Backdrop
      sx={{
        color: palette.brown[500],
        bgcolor: alpha('#000000', 0.3),
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={open}
    >
      {/* <GlobalStyles
        styles={{
          body: open
            ? {
                overflow: 'hidden !important',
                touchAction: 'none !important',
              }
            : {},
        }}
      /> */}
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}
